import { ClassicBanner, CLASSIC_BANNER_CTA } from "./ClassicBanner";
import { AramMayhemBanner, ARAM_MAYHEM_BANNER_CTA } from "./AramMayhemBanner";
import { WoWAppBanner, WOW_APP_BANNER_CTA } from "./WoWAppBanner";
import { AllStarBanner, ALL_STAR_BANNER_CTA } from "./AllStarBanner";

// ─────────────────────────────────────────────────────────────────────
// THE site-wide promo banner. Swapping which one is live is a manual,
// seasonal operation — change the ONE assignment below and nothing else.
//
// This exists because "which banner is current" used to be hardcoded in three
// unrelated places (useBanner's CURRENT_ACTIVE_BANNER, BannerContainer's
// CurrentBanner, and the website's MainContent), so a swap meant three edits
// and any one of them could be missed. The banner components themselves are
// kept around between seasons even when unused — an unimported module is
// tree-shaken out of the bundle, so keeping them costs nothing and deleting
// one only means recovering it from git the next time it comes round.
//
// Every banner takes the same props ({ url, className, onClick, onClose,
// utmSource }), which is what lets them be swapped by reference.
//
// NOTE ON `ctaId`: it is the localStorage key suffix (`ugg-cta-<ctaId>`) that
// records a dismissal. Never rename an existing one — that would resurface the
// banner for everyone who had already closed it. Changing which banner is live
// SHOULD change the id, so a new campaign shows even to people who dismissed
// the previous one.

interface BannerDescriptor {
  ctaId: string;
  Component: typeof ClassicBanner;
  defaultUrl: string;
}

const CLASSIC: BannerDescriptor = {
  ctaId: CLASSIC_BANNER_CTA,
  Component: ClassicBanner,
  defaultUrl: "https://u.gg/lol/classic-tier-list",
};

const ARAM_MAYHEM: BannerDescriptor = {
  ctaId: ARAM_MAYHEM_BANNER_CTA,
  Component: AramMayhemBanner,
  defaultUrl: "https://u.gg/lol/aram-mayhem-tier-list",
};

const WOW_APP: BannerDescriptor = {
  ctaId: WOW_APP_BANNER_CTA,
  Component: WoWAppBanner,
  defaultUrl: "https://u.gg/app?game=wow&utm_source=uggtop",
};

const ALL_STAR: BannerDescriptor = {
  ctaId: ALL_STAR_BANNER_CTA,
  Component: AllStarBanner,
  defaultUrl: "https://www.u.gg/plus",
};

// ↓↓↓ THE SWAP: point this at CLASSIC, ARAM_MAYHEM, WOW_APP, or ALL_STAR. ↓↓↓
export const CURRENT_BANNER = ALL_STAR;
